import { Badge } from '@/components/ui/badge';

export function EmailStatusBadge({ status }: { status: string }) {
  const normalizedStatus = status.toLowerCase();

  if (normalizedStatus === 'completed' || normalizedStatus === 'sent') {
    return (
      <Badge
        variant="outline"
        className="bg-green-50 text-green-700 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-800 text-[10px] h-5 px-1.5 font-normal"
      >
        Sent
      </Badge>
    );
  }

  if (normalizedStatus === 'failed') {
    return (
      <Badge
        variant="destructive"
        className="text-[10px] h-5 px-1.5 font-normal"
      >
        Failed
      </Badge>
    );
  }

  if (normalizedStatus === 'processing' || normalizedStatus === 'queued') {
    return (
      <Badge
        variant="outline"
        className="bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800 text-[10px] h-5 px-1.5 font-normal"
      >
        Processing
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className="text-[10px] h-5 px-1.5 font-normal">
      {status}
    </Badge>
  );
}

export function RecipientStatusBadge({
  status,
  error,
}: {
  status: string;
  error?: string;
}) {
  const normalizedStatus = status.toLowerCase();

  if (normalizedStatus === 'sent') {
    return (
      <div className="flex flex-col items-end">
        <div className="flex items-center text-green-700 text-xs font-medium bg-green-50 px-1.5 py-0.5 rounded dark:bg-green-900/20 dark:text-green-400">
          Sent
        </div>
      </div>
    );
  }

  if (normalizedStatus === 'failed') {
    return (
      <div className="flex flex-col items-end" title={error}>
        <div className="flex items-center text-destructive text-xs font-medium bg-destructive/10 px-1.5 py-0.5 rounded">
          Failed
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-end">
      <div className="flex items-center text-muted-foreground text-xs font-medium bg-muted px-1.5 py-0.5 rounded">
        {status}
      </div>
    </div>
  );
}
